module.exports = "<nav class=\"leftsettingbox\">\n  <ul class=\"list-unstyled settinglist\">\n    <li><a [routerLink]=\"['ecokra']\" hasPermission=\"reports.hr.ecokra.active\"\n        routerLinkActive=\"selected\"><strong>EcoKRA</strong></a></li>\n  </ul>\n</nav>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/hr/hr.component.html
// module id = ./src/app/reports/hr/hr.component.html
// module chunks = main